import {Box, Slider, Typography} from "@mui/material";
import React from "react";

export default function VerticalSliderSettingPanel({value, onchange, label, min, max, step, marks}) {
    return (
        <Box display="flex" flexDirection="row-reverse" alignItems="center" height={300}
             border={1}
             borderRadius={5}
             borderColor="grey.500"
             m={1}
             p={2}
        >
            <Slider
                orientation="vertical"
                value={value}
                onChange={onchange}
                sx={{ marginLeft: 5 }}
                min={min}
                max={max}
                step={step}
                marks={marks}
            />
            <Typography component="div" dangerouslySetInnerHTML={{ __html: label }}/>
        </Box>
    );
}